import { Navigate, useLocation } from "react-router-dom";
import { AppRoutes } from "@/infra/router";
import { LoadingOverlay } from "@akina/presentation";

function RootPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hasAuthCallbackParams = searchParams.has("code") && searchParams.has("state");

  if (hasAuthCallbackParams) {
    return <LoadingOverlay />;
  }

  return <Navigate replace to={AppRoutes.Home} />;
}

export { RootPage };
